import Offers from '@cont/Checkout/Offers/Offers';
import { fetchOfferList, fetchOfferFaqs } from '@actions/checkout';
import { redirectToRoute } from '@utils/route';
import { emptyList } from '@constants/empty';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const OffersPage = () => {
  return <Offers />;
};

OffersPage.pageInfo = {
  isMWebSupported: true,
  name: 'Offers',
  layoutOptions: {
    showFixedHeader: true
  }
};

OffersPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, res }) => {
    const { goalUID, goalSlug } = query;

    await store.dispatch(fetchOfferList(goalUID));
    const offerList = store.getState().checkout.offerList[goalUID] || emptyList;
    const goalDetails = store.getState().topologies.data[goalUID.toUpperCase()];

    if (!offerList.length) {
      return redirectToRoute(
        isServer,
        res,
        '/goal/[goalSlug]/[goalUID]',
        `/goal/${goalDetails?.goalSlug || goalSlug}/${goalUID}`
      );
    }
    await store.dispatch(fetchOfferFaqs());
  },
  OffersPage.pageInfo
);

export default OffersPage;
OffersPage.Layout = Layout;
OffersPage.Wrapper = PageReduxProvider;
